$(function () {

    $("[class*='menuLoad']").on("click", function () {
        $('.loading').removeClass('hide');
    })
});
